<button type="button" class="btn btn-default" (click)="exportToFile()">
  <span class="glyphicon glyphicon-download"></span> {{ title }}
</button>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵq.html